import { axios, AxiosResponse } from "@sdk/axios";
import type { PaginatedOptions } from "@sdk/utils/paginated-results";
import type {
  iNotification,
  iNotificationsQueryResult,
} from "./notifications.models";

type NotificationsApi = {
  configure: (config: { basePath?: string; token?: string }) => void;
  unreadCount: () => Promise<{ unreadCount: number }>;
  query: (req?: {
    query?: Record<string, unknown>;
    options?: PaginatedOptions;
  }) => Promise<iNotificationsQueryResult>;
  markRead: (id: string, isRead: boolean) => Promise<iNotification>;
  markAllRead: () => Promise<{ modifiedCount: number }>;
};

export class NotificationsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
    this.notifications.configure(config);
  }

  constructor(protected config: { basePath: string; token: string }) {
    this.notifications = {
      configure: (cfg: { basePath?: string; token?: string }) => {
        Object.assign(this.config, cfg);
      },
      unreadCount: async () => {
        const results: AxiosResponse<{ unreadCount: number }> = await axios.get(
          this.config.basePath + `/notifications/unread-count`,
          {
            headers: {
              Authorization: this.config.token,
            },
          }
        );
        return results.data;
      },
      query: async (req = {}) => {
        const results: AxiosResponse<iNotificationsQueryResult> =
          await axios.post(
            this.config.basePath + `/notifications/query`,
            req,
            {
              headers: {
                Authorization: this.config.token,
              },
            }
          );
        return results.data;
      },
      markRead: async (id: string, isRead: boolean) => {
        const results: AxiosResponse<iNotification> = await axios.patch(
          this.config.basePath + `/notifications/${id}/read`,
          { isRead },
          {
            headers: {
              Authorization: this.config.token,
            },
          }
        );
        return results.data;
      },
      markAllRead: async () => {
        const results: AxiosResponse<{ modifiedCount: number }> =
          await axios.post(
            this.config.basePath + `/notifications/mark-all-read`,
            {},
            {
              headers: {
                Authorization: this.config.token,
              },
            }
          );
        return results.data;
      },
    };
    this.notifications.configure(config);
  }

  notifications!: NotificationsApi;
}
